import { memoizeDeep, safeMerge } from "../common/utilities";
const setTheme = memoizeDeep(function (_ref) {
  let {
    fileselector,
    disabled
  } = _ref;
  let cssRoot = {},
      cssInstructionsWrapper = {},
      cssTriggerButton = {};

  if (fileselector) {
    cssRoot = fileselector.root;
    cssInstructionsWrapper = fileselector.instructionsWrapper;
    cssTriggerButton = fileselector.uploadButton;

    if (disabled) {
      cssRoot = safeMerge(cssRoot, fileselector.modifiers.disabled);
    }
  }

  return {
    cssRoot,
    cssInstructionsWrapper,
    cssTriggerButton
  };
});
export default function (_ref2) {
  var _theme$components;

  let {
    theme,
    disabled
  } = _ref2;
  const fileselector = theme === null || theme === void 0 ? void 0 : (_theme$components = theme.components) === null || _theme$components === void 0 ? void 0 : _theme$components.fileselector;
  return setTheme({
    fileselector,
    disabled
  });
}